import { Fragment, useEffect, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../../Layout/Common/common";
import { PriceRowSkeleton, PriceTableContainerSkeleton } from "../../../Skeleton/ProductListSkeleton";
import { ProductStockStatusContainer } from "../../../Layout/Common/productStockStatusContainer";

export const PriceBreakupTable = ({ data, stockStatus = null, labelledBy = "proPricing" }) => {
  const [priceData, setPriceList] = useState(null);
  const [stockStatusRaw, setStockStatusRaw] = useState("");
  const [stockData, setStockData] = useState(null);
  useEffect(() => {
    if (isValidArray(data)) setPriceList(data);
  }, [data]);

  useEffect(() => {
    if (stockStatus) {
      console.log("stockStatus", stockStatus);
      // setStockStatusRaw(stockStatus?.stockStatusRaw ?? "");
      setStockData(stockStatus);
    }
  }, [stockStatus]);

  return (
    <Fragment>
      <div className="dropdown-menu dropdown-menu-left" aria-labelledby={labelledBy}>
        <div className="proList-dropdown-info">
          <h5>Pricing Details</h5>
          {stockData && (
            <div className="bg-white p-2 stock-badge">
              <p className="m-0 fs-13 fw-semibold">
                <span className="">Stock</span> Availability
              </p>
              <ProductStockStatusContainer params={stockData} />
            </div>
          )}
          <div className="pricingDetails-dropdown">
            <div className="pricingDetails-header">
              <div className="cost-ex">Qty</div>
              <div className="cost-ex">Cost Ex</div>
              <div className="cost-ex">Cost Inc</div>
            </div>

            <div className="pricingDetails-content">
              {priceData && isValidArray(priceData) ? (
                priceData.map((item, index) => (
                  <div
                    className={`pricingDetails-content-list   
                     ${item.actualQty == "your_price" && " pricingDetails-content-listGreen"}
                  `}
                    key={index}
                  >
                    <div className="price-ex">{item.qty}</div>
                    <div className="price-ex">$ {ConvertToFloat(item.priceExc)}</div>
                    <div className="price-ex">${ConvertToFloat(item.priceInc)}</div>
                  </div>
                ))
              ) : (
                <PriceTableContainerSkeleton count={3} />
              )}
            </div>
          </div>
        </div>
        {/* Dropdown inside content */}
      </div>
    </Fragment>
  );
};
